import { AfterViewInit, ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core'
import { FormBuilder, FormGroup, Validators } from '@angular/forms'
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog'
import { IFieldConfig } from 'src/app/domain/IFieldConfig'
import { filterFields } from '../crud-config'
import { ToastService } from 'src/app/shared/services/toast/toast.service'
import { FaqService } from '../crud-service'
import { PermissionService } from 'src/app/shared/permission.service'
import { debounceTime, distinctUntilChanged, filter, take } from 'rxjs/operators'

@Component({
  selector: 'app-filter-faq-dialog',
  templateUrl: './filter-faq-dialog.component.html',
  styleUrls: ['./filter-faq-dialog.component.sass']
})
export class FilterFaqDialogComponent implements OnInit, AfterViewInit {

  form: FormGroup
  // Usamos o array de configurações para os filtros
  config: IFieldConfig[] = filterFields
  typeCes: string = 'default'

  constructor(
    public dialogRef: MatDialogRef<FilterFaqDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private fb: FormBuilder,
    private toastService: ToastService,
    private eventsService: FaqService,
    public permissionService: PermissionService
  ) { }

  ngOnInit(): void {
    this.form = this.fb.group({})
    this.config.forEach(field => {
      this.form.addControl(field.name, this.fb.control('', field.validation || []))
    })

    // Lógica para bloquear os demais campos se algum for preenchido
    this.form.valueChanges.subscribe(values => {
      const filledFields = Object.keys(values).filter(key => values[key] !== null && values[key] !== '')
      if (filledFields.length > 0) {
        Object.keys(this.form.controls).forEach(key => {
          if (!filledFields.includes(key)) {
            this.form.get(key)?.disable({ emitEvent: false })
          }
        })
      } else {
        Object.keys(this.form.controls).forEach(key => {
          if (this.form.get(key)?.disabled) {
            this.form.get(key)?.enable({ emitEvent: false })
          }
        })
      }
    })

    // Quando o usuário preencher algum campo (e o formulário estiver válido),
    // fecha automaticamente o modal e retorna os dados do filtro.
    this.form.valueChanges
      .pipe(
        debounceTime(300),
        distinctUntilChanged(),
        filter(val => this.form.valid && Object.values(val).some(v => v !== null && v !== '')),
        take(1)
      )
      .subscribe(val => {
        this.applyFilter()
      })
  }

  ngAfterViewInit(): void {
    this.cdr.detectChanges()
  }

  onCancel(): void {
    this.dialogRef.close()
  }

  applyFilter(): void {
    if (this.form.valid) {
      // Fecha o modal e retorna os valores do formulário
      this.dialogRef.close(this.form.getRawValue())
    } else {
      this.toastService.showError('Por favor, corrija os erros no formulário.')
    }
  }

  // Retorna a configuração de um campo pelo nome
  getFieldConfig(name: string): IFieldConfig {
    return this.config.find(c => c.name === name)!
  }
}
